export default isSportEvent =>
  isSportEvent
    ? {
        sportEventData: {
          teamName1Abreviated: "",
          teamName1: "",
          teamLogo1: "",
          teamLogoAsset1: {
            codename: "",
            image: "",
            description: "",
            categoryIds: null,
          },
          teamName2Abreviated: "",
          teamName2: "",
          teamLogo2: "",
          teamLogoAsset2: {
            codename: "",
            image: "",
            description: "",
            categoryIds: null,
          },
          scoreboardTemplateId: null,
          scoreboardType: null,
        },
      }
    : {};
